export enum DefaultModelTypeNameIds
{
    Item = "Item"
}

export enum ModelTypeConstants
{
    Line = "Line"
}
